<div class="p-a-10 p-r-12 p-a-5-s p-a-5-m">
    <span class="float-right p2 m-l _linkEl">
        @if (sectionCtaLink) {
        <a class="button-inline-2"
           [routerLink]="sectionCtaLink">
            <span>{{sectionCta | translate}}</span>
        </a>
        }
        <ng-content select="[section2cta]"></ng-content>
    </span>

    @switch (!!sectionIcon) {
    @case (true) {
    <icon-label class="flex-middle"
                [icon]="sectionIcon"
                [textClass]="'p1'">{{ sectionTitle | translate }}</icon-label>
    }
    @case (false) {
    <p class="p1">{{sectionTitle | translate}}</p>
    }
    }


    @if (sectionSubtitle) {
    <p class="c1 col-11">{{sectionSubtitle | translate}}</p>
    }
    <div class="m-t-5">
        <ng-content></ng-content>
        <ng-content select="[section2content]"></ng-content>
    </div>
</div>
